module.exports = __webpack_public_path__ + "img/microphone-dark.c3511782.svg";